import { FC } from 'react'

type ShadowedComponents = {
  ProductPage: {
    BeforeProductName: FC | null
  }
}

declare global {
  interface Window {
    ['instore-core.ShadowedComponents']?: ShadowedComponents
  }
}

// eslint-disable-next-line import/no-mutable-exports
export let ShadowedComponents: ShadowedComponents | undefined

/**
 * Today our checkout-instore is loaded as library for the instore-core
 * This means that this code will be loaded before the customization code
 * done using shadowing. So we are using getters/setters to access the
 * shadowed components here
 *
 * So this solution only works with lazy evaluation, so this works:
 *
 * const CustomPage = (props) => <ShadowedComponents.CustomPage {...props} />
 *
 * This will fail:
 *
 * const CustomPage = ShadowedComponents.CustomPage
 *
 */
Object.defineProperty(window, 'instore-core.ShadowedComponents', {
  configurable: true,
  get() {
    return ShadowedComponents
  },
  set(value: ShadowedComponents) {
    ShadowedComponents = value
  },
})
